import type { ReactNode } from 'react'
import { useParams } from 'react-router-dom'

import { ConnectorDetailView } from './connector-detail.view'
import { ConnectorsListView } from './connectors-list.view'

export const ConnectorsSettingsView: React.FC = (): ReactNode => {
  const { providerSlug } = useParams<{ providerSlug?: string }>()

  if (providerSlug) {
    return <ConnectorDetailView />
  }

  return <ConnectorsListView />
}

ConnectorsSettingsView.displayName = 'ConnectorsSettingsView'
